import Popper from 'popper.js';
import { memo, useCallback, useEffect, useMemo, useRef, useState, } from 'react';
const defaultProps = {
    onClose: () => { },
    onOpen: () => { },
    popperProps: {},
    position: 'bottom-start',
};
const PopoverManager = ({ children, onClose = defaultProps.onClose, onOpen = defaultProps.onOpen, popperProps = defaultProps.popperProps, position = defaultProps.position, }) => {
    const [isOpen, setIsOpen,] = useState(false);
    const contentRef = useRef(null);
    const targetRef = useRef(null);
    const [popper, setPopper,] = useState();
    const isBodyClick = useCallback((element) => {
        if (!element) {
            return true;
        }
        if (element !== contentRef.current
            && element !== targetRef.current) {
            return isBodyClick(element.parentElement);
        }
        return false;
    }, []);
    const closePopover = useCallback((event) => {
        onClose(event);
        setIsOpen(false);
        popper === null || popper === void 0 ? void 0 : popper.destroy();
        setPopper(undefined);
    }, [
        onClose,
        popper,
    ]);
    const positionPopover = useCallback(() => {
        if (targetRef.current !== null
            && contentRef.current !== null) {
            setPopper(new Popper(targetRef.current, contentRef.current, Object.assign(Object.assign({}, popperProps), { placement: position })));
        }
    }, [
        popperProps,
        position,
    ]);
    const openPopover = useCallback((event) => {
        onOpen(event);
        setIsOpen(true);
        positionPopover();
    }, [
        positionPopover,
        onOpen,
    ]);
    const togglePopover = useCallback((event) => {
        isOpen
            ? closePopover(event)
            : openPopover(event);
    }, [
        closePopover,
        isOpen,
        openPopover,
    ]);
    useEffect(() => {
        if (!isOpen) {
            return () => { };
        }
        const isBodyClick = (element) => {
            if (!element) {
                return true;
            }
            if (element !== contentRef.current
                && element !== targetRef.current) {
                return isBodyClick(element.parentElement);
            }
            return false;
        };
        const closePopoverFromBody = (event) => {
            if (event.target !== null
                && isBodyClick(event.target)) {
                closePopover(event);
            }
        };
        const allDocuments = [
            document,
            ...(Array
                .from(document
                .querySelectorAll('iframe'))
                .map((iframe) => (iframe.contentDocument))
                .filter(Boolean)),
        ];
        allDocuments
            .forEach((doc) => (doc === null || doc === void 0 ? void 0 : doc.addEventListener('click', closePopoverFromBody, false)));
        return () => {
            allDocuments
                .forEach((doc) => (doc === null || doc === void 0 ? void 0 : doc.removeEventListener('click', closePopoverFromBody, false)));
        };
    }, [
        closePopover,
        isOpen,
    ]);
    const childProps = useMemo(() => ({
        closePopover,
        contentRef,
        isOpen,
        openPopover,
        targetRef,
        togglePopover,
    }), [
        closePopover,
        contentRef,
        isOpen,
        openPopover,
        targetRef,
        togglePopover,
    ]);
    return (children(childProps));
};
const MemoizedPopoverManager = memo(PopoverManager);
export { MemoizedPopoverManager as PopoverManager };
// MC-1068 Temporary hack for Storybook.
export default PopoverManager;
